// extracted by mini-css-extract-plugin
export default {"animes-container":"AnimeCardContainer_animes-container__-ECXB"};